export const getPaddingForContent = (isMobile: boolean) => (isMobile ? '16px 0px' : '24px 40px');
